import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import useScreen from 'hooks/useScreen';
import useProductCardContext from 'data-hooks/useProductCardContext';
import BarbieLogo from 'assets/images/made-for-barbie-logo.png';
import BipocLogo from 'assets/images/bipoc-badge.png';
import IconGreenguardGold from 'components/icons/PDPSellingAttributes/IconGreenguardGold';
import isT1Image from 'commons/isT1Image';
import { IMAGE_FLIP_SKUS } from 'commons/constants';
import ProductCardConfigImage from './ProductCardConfigImage';
import ProductCardStudioImage from './ProductCardStudioImage';
import ProductCardPhotoSlider from './ProductCardPhotoSlider';
const ProductCardPhotoSquare = t0 => {
  const $ = _c(36);
  const {
    enableMobileCarousel
  } = t0;
  const {
    image,
    secondaryImage,
    secondaryImageCropData,
    variantsToShow,
    campaign,
    sku
  } = useProductCardContext();
  const {
    isMobile
  } = useScreen();
  const isDesktop = !isMobile;
  let t1;
  if ($[0] !== sku) {
    t1 = sku?.split("-").some(_temp) ?? false;
    $[0] = sku;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isFlipped = t1;
  const showSecondaryImageAsPrimary = !variantsToShow?.length && !image && !!secondaryImage;
  let t2;
  if ($[2] !== campaign || $[3] !== image || $[4] !== isFlipped) {
    t2 = <ProductCardConfigImage image={image} campaign={campaign} isFlipped={isFlipped} />;
    $[2] = campaign;
    $[3] = image;
    $[4] = isFlipped;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const primaryImageElement = t2;
  const isSecondaryConfigImage = isT1Image(secondaryImage) && !secondaryImageCropData;
  let t3;
  bb0: {
    if (!secondaryImage) {
      t3 = null;
      break bb0;
    }
    if (isSecondaryConfigImage) {
      let t4;
      if ($[6] !== isFlipped || $[7] !== secondaryImage) {
        t4 = <ProductCardConfigImage image={secondaryImage} isFlipped={isFlipped} />;
        $[6] = isFlipped;
        $[7] = secondaryImage;
        $[8] = t4;
      } else {
        t4 = $[8];
      }
      t3 = t4;
      break bb0;
    }
    let t4;
    if ($[9] !== isMobile || $[10] !== secondaryImage || $[11] !== secondaryImageCropData) {
      t4 = <ProductCardStudioImage cropData={secondaryImageCropData} image={secondaryImage} isMobile={isMobile} />;
      $[9] = isMobile;
      $[10] = secondaryImage;
      $[11] = secondaryImageCropData;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    t3 = t4;
  }
  const secondaryImageElement = t3;
  const firstImageToShow = showSecondaryImageAsPrimary ? secondaryImageElement : primaryImageElement;
  const secondImageToShow = showSecondaryImageAsPrimary ? null : secondaryImageElement;
  const showCarouselOnMobile = enableMobileCarousel && !!secondImageToShow;
  const t4 = (isDesktop || !showCarouselOnMobile) && firstImageToShow;
  let t5;
  if ($[13] !== campaign) {
    t5 = campaign === "barbie" && <img src={BarbieLogo} alt="barbie-logo" className="w-12 h-12 absolute bottom-2 right-4" />;
    $[13] = campaign;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== campaign) {
    t6 = campaign === "bipoc" && <img src={BipocLogo} alt="bipoc-owned-logo" className="w-12 h-12 absolute bottom-2 right-4" />;
    $[15] = campaign;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== campaign) {
    t7 = campaign === "greenguard" && <IconGreenguardGold className="w-12 h-12 absolute bottom-2 right-4 z-10" />;
    $[17] = campaign;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t5 || $[20] !== t6 || $[21] !== t7) {
    t8 = <div className="w-full flex flex-row justify-end absolute bottom-2">{t5}{t6}{t7}</div>;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== isDesktop || $[24] !== secondImageToShow) {
    t9 = isDesktop && !!secondImageToShow && <div className="absolute w-full h-full top-0 left-0 transition-opacity duration-700 ease-out opacity-0 group-hover/product-card:opacity-100 bg-gray-light8 flex flex-col items-center justify-center">{secondImageToShow}</div>;
    $[23] = isDesktop;
    $[24] = secondImageToShow;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== firstImageToShow || $[27] !== isMobile || $[28] !== secondImageToShow || $[29] !== showCarouselOnMobile) {
    t10 = isMobile && showCarouselOnMobile && <ProductCardPhotoSlider image1={firstImageToShow} image2={secondImageToShow} />;
    $[26] = firstImageToShow;
    $[27] = isMobile;
    $[28] = secondImageToShow;
    $[29] = showCarouselOnMobile;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== t10 || $[32] !== t4 || $[33] !== t8 || $[34] !== t9) {
    t11 = <div className="aspect-square relative bg-gray-light8 flex flex-col [transition:background-color_0.3s_ease-in-out] items-center justify-center overflow-hidden min-h-0">{t4}{t8}{t9}{t10}</div>;
    $[31] = t10;
    $[32] = t4;
    $[33] = t8;
    $[34] = t9;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  return t11;
};
ProductCardPhotoSquare.propTypes = {
  enableMobileCarousel: PropTypes.bool
};
export default ProductCardPhotoSquare;
function _temp(optionSku) {
  return IMAGE_FLIP_SKUS.includes(optionSku);
}